import React, { useState } from 'react';
import { MarketplaceSellerProfile } from '../../../slices/profiles-data-slice/models/marketplace-seller-profile';
import { OwnershipTypeOptions } from '../../../slices/marketplace/timeline/models/enums/ownership-type.enum';
import { LocationTypeOptions } from '../../../slices/marketplace/timeline/models/enums/location-type.enum';
import { RevenueGrowthRateOptions } from '../../../slices/marketplace/timeline/models/enums/revenue-growth.enum';
import './AnonymizedProfile.scss';
import { useServiceFocuses } from '../../../custom-hooks/useServiceFocuses';
import {
    mapServiceFocusesToOptions,
    isOtherFocus,
    getOtherFocus,
} from '../../../containers/UserPages/Login/Modals/PracticeRegistrationForm/utils';

interface AnonymizedProfileProps {
    profileData?: MarketplaceSellerProfile;
}

const AnonymizedProfile: React.FC<AnonymizedProfileProps> = (props) => {
    const { profileData } = props;
    const serviceFocuses = useServiceFocuses();
    const serviceFocusOptions = mapServiceFocusesToOptions(serviceFocuses);
    const [activePracticeIndex, setActivePracticeIndex] = useState(0);

    const practices = profileData?.practiceProfiles || [];
    const activePractice = practices[activePracticeIndex];

    const renderTabs = () => {
        if (practices.length <= 1) return null;

        return (
            <div className="RRT__container">
                <div className="RRT__tabs">
                    {practices.map((practice, index) => (
                        <div
                            key={practice.id}
                            className={
                                activePracticeIndex === index
                                    ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                    : 'RRT__tab'
                            }
                            onClick={() => setActivePracticeIndex(index)}>
                            Practice {index + 1}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const getServiceFocusLabel = (): string => {
        if (!activePractice) return '';

        const isOther = isOtherFocus(
            serviceFocuses,
            activePractice.practiceFocusType
        );

        if (isOther) {
            return (
                activePractice.otherPracticeType ||
                getOtherFocus(serviceFocuses).name ||
                ''
            );
        }

        return serviceFocusOptions[activePractice.practiceFocusType] || '';
    };

    const renderPracticeInfo = () => {
        if (!activePractice) return null;

        return (
            <div className="info-section">
                <div className="section-title">Practice Information</div>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="label">Ownership Type</span>
                        <span className="value">
                            {activePractice.practiceOwnershipType
                                ? OwnershipTypeOptions[
                                      activePractice.practiceOwnershipType
                                  ]
                                : ''}
                        </span>
                    </div>
                    <div className="info-item">
                        <span className="label">Service Focus</span>
                        <span className="value">{getServiceFocusLabel()}</span>
                    </div>
                    <div className="info-item">
                        <span className="label">Number of FTE DVMs</span>
                        <span className="value">
                            {activePractice.fteDvms || ''}
                        </span>
                    </div>
                    <div className="info-item">
                        <span className="label">Revenue Growth Rate</span>
                        <span className="value">
                            {activePractice.revenueGrowthRate
                                ? RevenueGrowthRateOptions[
                                      activePractice.revenueGrowthRate
                                  ]
                                : ''}
                        </span>
                    </div>
                    <div className="info-item">
                        <span className="label">Location Type</span>
                        <span className="value">
                            {activePractice.practiceLocations?.[0]?.locationType
                                ? LocationTypeOptions[
                                      activePractice.practiceLocations[0]
                                          .locationType
                                  ]
                                : ''}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="anonymized-profile">
            <div className="profile-content">
                {renderTabs()}
                <div className="profile-info">{renderPracticeInfo()}</div>
            </div>
        </div>
    );
};

export default AnonymizedProfile;
